// Material UI
import { makeStyles } from '@material-ui/core';
// Consts
import { purple } from '@material-ui/core/colors';
import { neutral } from '../../../../shared/styles/colors';

export default makeStyles(theme => ({
  root: {
    padding: '1rem 0.625rem',
  },
  customAlertRoot: {
    color: purple[60],
    fontFamily: 'PP Object Sans',
    fontWeight: 400,
    backgroundColor: purple[10],
  },
  description: {
    color: neutral[80],
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontFamily: 'PP Object Sans',
    marginRight: '0.5rem',
  },
  body: {
    display: 'grid',
    gridRowGap: 10,
    justifyItems: 'center',
  },
  secondaryAlert: {
    zIndex: 100,
    backgroundColor: neutral['20'],
    color: neutral['80'],
    fontFamily: 'PP Object Sans',
    '& svg': {
      fill: {
        color: neutral['80'],
      },
    },
  },
  title: {
    color: neutral[80],
    fontSize: '0.625rem',
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  content: {
    fontFamily: 'PP Object Sans',
  },
  titleWrapper: {
    borderBottom: 'none',
  },
}));
